import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames';

import throttler from 'rebook/apps/utils/throttler';
import Button from 'rebook/apps/base/components/Button';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import * as AuthorBookListActions from 'rebook/apps/catalog/actions/AuthorBookListActions';
import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import * as AuthorDetailActions from 'rebook/apps/catalog/actions/AuthorDetailActions';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';
import AuthorDetailHeader from 'rebook/apps/catalog/components/AuthorDetailHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import { AUTHOR_SUBSCRIBE_MESSAGES } from 'rebook/apps/catalog/constants';

import styles from './style.scss';


const DELAY_BETWEEN_FETCH = 2000;

class AuthorBookListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(AuthorBookListActions.fetchInitialData(match));
  }

  constructor(props) {
    super(props);
    this.state = {
      subType: '',
      showModalWindow: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.AuthorDetailActions.fetchInitialData(match, location);
    this.props.AuthorBookListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.AuthorBookListActions.resetData();
    this.props.AuthorDetailActions.resetData();
  }

  // componentWillReceiveProps(nextProps) {
  //   // fetch context for new author slug
  //   const authorSlug = nextProps.match.params.authorSlug;
  //   if (authorSlug && authorSlug !== this.props.match.params.authorSlug) {
  //     this.props.AuthorBookListActions.resetData();
  //     this.props.AuthorBookListActions.fetchInitialData(nextProps.match, nextProps.location);
  //   }
  // }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props;
    const authorSlug = match.params.authorSlug;

    if (authorSlug && authorSlug !== prevProps.match.params.authorSlug) {
      this.props.AuthorDetailActions.resetData();
      this.props.AuthorBookListActions.resetData();
      this.props.AuthorBookListActions.fetchInitialData(nextProps.match, nextProps.location);
      this.props.AuthorDetailActions.fetchInitialData(match, location);
    }
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.AuthorBookListActions.fetchBookList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    const type = get(this.props, 'match.params.bookType', 'text');
    this.props.AuthorBookListActions.fetchBookList({ orderBy, type });
  }

  filterBySubscriptionType(subscriptionId) {
    this.props.AuthorBookListActions.fetchBookList({ subscriptionId });
  }

  changeBookType(bookType) {
    this.props.AuthorBookListActions.fetchBookList({ bookType });
  }

  resetFilters() {
    this.props.AuthorBookListActions.fetchBookList({
      subscriptionId: null,
      orderBy: 'popular',
      bookType: null,
    });
  }

  fetchAuthorDetail() {
    const { subType } = this.state;
    this.props.AuthorDetailActions.fetchDetail(this.props.match)
      .then(() => {
        if (subType === 'sub') {
          this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.SUBSCRIBE_SUCCESS);
        }
        if (subType === 'unsub') {
          this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.UNSUBSCRIBE_SUCCESS);
        }
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  subscribe() {
    const { authorDetail } = this.props;
    this.props.AuthorDetailActions.fetchSubscribeUserToAuthor()
      .then(() => {
        ga('send', 'event', {
          eventCategory: 'ContentSubscription',
          eventAction: 'PushButtonAuthor',
          eventLabel: authorDetail.author.cover_name,
        });
        yaMetrikaReachGoal('SubscribeAuthor');
        throttler(this.fetchAuthorDetail.bind(this), DELAY_BETWEEN_FETCH);
        return null;
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  unsubscribe() {
    const { authorDetail } = this.props;
    this.props.AuthorDetailActions.fetchUnsubscribeUserToAuthor()
      .then(() => {
        ga('send', 'event', {
          eventCategory: 'ContentSubscription',
          eventAction: 'UnsubscribeAuthor',
          eventLabel: authorDetail.author.cover_name,
        });
        throttler(this.fetchAuthorDetail.bind(this), DELAY_BETWEEN_FETCH);
        return null;
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  addToFavorite() {
    const { isLoading } = this.state;
    const { user, authorDetail } = this.props;
    if (isLoading) {
      return null;
    }

    if (!user) {
      this.props.AuthFormActions.showForm();
      return null;
    }
    if (user && user.is_fake_email) {
      this.setState({ showModalWindow: true });
      return null;
    }
    if (authorDetail.isFollowedByUser) {
      this.setState({ isLoading: true, subType: 'unsub' });
      this.unsubscribe();
      return null;
    }
    else {
      this.setState({ isLoading: true, subType: 'sub' });
      this.subscribe();
      return null;
    }
  }

  handleClickToSettingsLink() {
    document.querySelector('body').classList.remove('isNotScrollable');
    const { authorDetail } = this.props;
    ga('send', 'event', {
      eventCategory: 'ContentSubscription',
      eventAction: 'GoToMail',
      eventLabel: authorDetail.author.cover_name,
    });
  }

  getModalWindow() {
    return (
      <ModalDialog
        fullSizeForSmall
        extraClassname={styles.modalWindowContainer}
        onClose={() => {
          this.closeWindow();
        }}
        dialog={
          {
            id: '1',
            content:
              <div className={classNames(styles.unavailableInformationWindow, 'jest-unavailable-book-modal-window')}>
                <div className={styles.modalWindowHeader}>
                  <div className={styles.modalWindowHeaderText}>
                    <span>
                      Добавьте электронную почту в ваш профиль
                    </span>
                  </div>
                </div>
                <div className={styles.modalWindowText}>
                  <span>
                    Чтобы получать уведомления о новых книгах, пожалуйста, оставьте нам почту
                  </span>
                </div>
                <Button theme="secondary" link="/account/edit/"
                  extraClassName={styles.linkToSettingsButton}
                  handleClick={() => { this.handleClickToSettingsLink(); }}>
                  <span className={styles.settingsLinkText}>
                    В настройки
                  </span>
                </Button>
              </div>,
          }
        } />
    );
  }

  render() {
    const { user, authorBookList, authorDetail } = this.props;
    const {
      author, books, orderBy, pageNumber, lastPageNumber, subscriptionId, bookType,
    } = authorBookList;
    const { isFollowedByUser } = authorDetail;
    const { isLoading, showModalWindow } = this.state;
    const isAudio = get(this.props, 'match.params.bookType', null) === 'audio';
    const modalWindow = this.getModalWindow();
    return author
      ? (
        <React.Fragment>
          {showModalWindow && modalWindow}
          <div className="section">
            <BreadCrumbs links={[
              { text: 'Библиотека', url: '/catalog/' },
              { text: get(author, 'cover_name', ''), url: get(author, 'absolute_url', '') },
              {
                text: `Все ${isAudio ? 'аудио' : ''}книги автора ${get(author, 'cover_name', '')}`,
                url: `${get(author, 'absolute_url', '')}books/${isAudio ? 'audio' : ''}`,
              },
            ]} />
          </div>
          <AuthorDetailHeader photo={author.photo} authorUrl={author.share_url}
            name={author.cover_name}
            user={user}
            isLoading={isLoading}
            isFollowedByUser={isFollowedByUser}
            handleAddToFavorite={() => { this.addToFavorite(); }}
            booksCount={author.active_book_count} />
          <div className="section">
            {author && author.active_book_count > 1 && (
              <div className={styles.filters}>
                <CatalogFilter
                  orderBy={orderBy}
                  subscriptionId={subscriptionId}
                  bookType={bookType}
                  isSubscriptionEnabled={!isAudio}
                  isBookTypeEnabled={!isAudio}
                  isResultEmpty={books && books.length === 0}
                  onChangeSubscription={(value) => this.filterBySubscriptionType(value)}
                  onChangeOrder={(value) => this.changeOrderBy(value)}
                  onChangeBookType={((value) => this.changeBookType(value))}
                  onResetFilter={()=>this.resetFilters()} />
              </div>
            )}
            {books && books.length !== 0 && (
              <React.Fragment>
                {books.length > 0
                  ? <BookList books={books} />
                  : <BookList books={[...Array(5)]} />}
              </React.Fragment>
            )}
            { books && books.length === 0 && <EmptyFilterResult /> }
            {lastPageNumber > 1 && (
              <ContextPagination
                onPageChange={(pageNumber) => this.changePage(pageNumber)}
                currentPage={pageNumber}
                lastPage={lastPageNumber} />
            )}
          </div>
        </React.Fragment>
      )
      : null;
  }
}

AuthorBookListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      authorSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    authorBookList: state.authorBookList,
    user: state.user,
    authorDetail: state.authorDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthorBookListActions: bindActionCreators(AuthorBookListActions, dispatch),
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
    AuthorDetailActions: bindActionCreators(AuthorDetailActions, dispatch),
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthorBookListView);
